import {
  Flame,
  CloudRain,
  TreePine,
  Camera,
  Sunrise,
  Users,
  Leaf,
  Sparkles,
  Wifi,
  Home as HomeIcon,
  Coffee,
  UsersRound,
  Heart,
  Car,
  Droplet,
  Flower2,
  UtensilsCrossed,
  Ban,
  Sprout,
  Dice5,
} from "lucide-react";

const activities = [
  { icon: Flame, title: "Campfire", desc: "Cozy fireside evenings under starlit skies", span: "sm:col-span-2" },
  { icon: Sparkles, title: "Bonfire Night", desc: "Songs, stories & warm conversations" },
  { icon: CloudRain, title: "Rain Dance", desc: "Monsoon magic in the Ghats" },
  { icon: TreePine, title: "Coffee Estate Walk", desc: "Guided walks through the plantation" },
  { icon: Camera, title: "Nature Photography", desc: "Endless frames worth capturing" },
  { icon: Sunrise, title: "Sunrise View", desc: "Golden mornings over misty hills", span: "sm:col-span-2" },
  { icon: Dice5, title: "Indoor Family Games", desc: "Chess & Carom for cozy evenings" },
  { icon: Sprout, title: "Yoga & Meditation", desc: "Peaceful morning practice in the garden" },
  { icon: Leaf, title: "Relax in Nature", desc: "Disconnect and just be" },
];

const amenities = [
  { icon: Wifi, label: "Free WiFi" },
  { icon: HomeIcon, label: "Traditional House" },
  { icon: Coffee, label: "Coffee Estate" },
  { icon: UsersRound, label: "Family Friendly" },
  { icon: Heart, label: "Couple Friendly" },
  { icon: Sparkles, label: "Bonfire" },
  { icon: Flame, label: "Campfire" },
  { icon: Car, label: "Parking" },
  { icon: Droplet, label: "Hot Water" },
  { icon: Flower2, label: "Garden" },
  { icon: UtensilsCrossed, label: "Traditional Food" },
  { icon: Leaf, label: "Peaceful Environment" },
  { icon: Ban, label: "No Pets Allowed" },
];

const Activities = () => {
  return (
    <section
      id="activities"
      data-testid="activities-section"
      className="relative py-24 md:py-32 bg-[#1B4332] text-white overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="max-w-3xl reveal">
          <div className="flex items-center gap-3 mb-5">
            <span className="h-px w-8 bg-[#D4AF37]" />
            <span className="text-[11px] tracking-[0.3em] uppercase text-[#D4AF37] font-medium">
              Activities
            </span>
          </div>
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
            Experiences you'll{" "}
            <span className="italic font-light text-[#E8C866]">
              never forget
            </span>
          </h2>
        </div>

        {/* Activities bento */}
        <div className="mt-14 grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {activities.map((a, i) => (
            <div
              key={a.title}
              className={`reveal group p-6 rounded-2xl bg-white/5 backdrop-blur border border-white/10 hover:border-[#D4AF37]/50 hover:-translate-y-1 transition-all duration-300 ${a.span || ""}`}
              style={{ animationDelay: `${i * 0.05}s` }}
              data-testid={`activity-${i}`}
            >
              <div className="w-12 h-12 rounded-full bg-[#D4AF37]/15 border border-[#D4AF37]/30 flex items-center justify-center text-[#D4AF37] group-hover:bg-[#D4AF37] group-hover:text-[#1B4332] transition-colors">
                <a.icon size={22} strokeWidth={1.5} />
              </div>
              <div className="mt-5 font-heading text-xl">{a.title}</div>
              <div className="mt-1.5 text-white/60 text-sm leading-relaxed">
                {a.desc}
              </div>
            </div>
          ))}
        </div>

        {/* Amenities */}
        <div className="mt-24">
          <div className="flex items-end justify-between flex-wrap gap-4 reveal">
            <div>
              <div className="flex items-center gap-3 mb-3">
                <span className="h-px w-8 bg-[#D4AF37]" />
                <span className="text-[11px] tracking-[0.3em] uppercase text-[#D4AF37]">
                  Amenities
                </span>
              </div>
              <h3 className="font-heading text-3xl md:text-4xl leading-tight">
                Thoughtful comforts,{" "}
                <span className="italic font-light text-[#E8C866]">every day</span>
              </h3>
            </div>
            <div className="text-white/60 text-sm max-w-sm">
              Everything you need for a relaxed stay, thoughtfully arranged.
            </div>
          </div>

          <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
            {amenities.map((am, i) => (
              <div
                key={am.label}
                className="reveal flex items-center gap-3 py-3 px-4 rounded-xl border border-white/10 bg-white/5 hover:bg-white/10 transition-colors"
                style={{ animationDelay: `${i * 0.03}s` }}
                data-testid={`amenity-${i}`}
              >
                <am.icon size={18} strokeWidth={1.5} className="text-[#D4AF37] shrink-0" />
                <span className="text-sm text-white/85">{am.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Activities;
